import {
  Autocomplete,
  Box,
  Button,
  Drawer,
  Stack,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import CommonDatePicker from '../../../../Components/Common Components/CommonDatePicker';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import {
  CommonGridToolBarWithFilterTextCustom,
  CommonTimeRangePicker
} from '../../../../Components/Common Components/CommonComponents';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { formatDate, timeOnlyConvert, formatDateAndTimeMeth2, ContentInTooltip } from '../../../../Components/CommonFunctions/CommonFunctions';
import { DateTime } from 'luxon';

class PharmacyAuditLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      pageSize: 10,

      fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      dateIndex: 1,

      auditLogData: [],
      totalRecords: 0,

      FilteredFromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      FilteredToDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),

      FilterDatas: {
        startTime: null,
        endTime: null,
        onError: false
      },

      timeError: false,
      FilterOpen: false,
      isLoader: false,
      isErrorMsg: false,
      isErrorMsgText: '',

      filterType: '',
      filterUser: '',
      usersList: [],

      auditTypes: [
        { value: 'PO Drug Delete', label: 'PO Drug Delete' },
        { value: 'Po Vendor Change', label: 'PO Vendor Change' },
        { value: 'Po Billno Change', label: 'PO Bill No Change' }
      ]
    };
  }

  componentDidMount() {
    this.getAuditLogData();
    this.getUsersList();
  }

  errorMessage = (message) => {
    this.setState({ isErrorMsg: true, isErrorMsgText: message });
  };

  onChangeHandler = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  FilterDate = (from, to, index) => {
    this.setState(
      { fromDate: from, toDate: to, dateIndex: index },
      () => {
        this.state.FilterDatas.endTime = null;
        this.setState({ FilterDatas: this.state.FilterDatas });
      }
    );
  };

  LoaderFunction = (key) => {
    this.setState({ isLoader: key });
  };

  normalizeAuditRow = (item = {}) => {
    const timestamp = formatDateAndTimeMeth2(item.created_date) || '-';
    const module = item.modified_type || '-';
    const action = item.reason || '-';
    const user = item.created_by || item.modified_by || '-';

    return {
      id: item.id,
      timestamp,
      module,
      action,
      user,
      actual_data: item.actual_data,
      modified_data: item.modified_data,
      ...item
    };
  };

  getAuditLogData = () => {
    try {
      this.LoaderFunction(true);
      const { fromDate, toDate, filterType, filterUser, FilterDatas } = this.state;

      let start_time = FilterDatas.startTime ? new Date(FilterDatas.startTime) : '';
      let end_time = FilterDatas.endTime ? new Date(FilterDatas.endTime) : '';
      let setStartTime =
        start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
      let setEndTime =
        end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);

      let params = {
        from_date: fromDate,
        to_date: toDate
      };

      if (filterType) params.type = filterType;
      if (filterUser) params.created_by = filterUser;
      if (setStartTime && setEndTime) {
        params.start_time = setStartTime;
        params.end_time = setEndTime;
      }

      const queryString = Object.keys(params)
        .map((key) => `${key}=${encodeURIComponent(params[key])}`)
        .join('&');

      RestAPIService.getAll(`${Serviceurls.PHARMACY_AUDIT_LOG}?${queryString}`)
        .then((response) => {
          if (response.data.status === 'success') {
            const raw = response.data.data || [];
            const normalized = raw.map(this.normalizeAuditRow);

            this.setState(
              {
                auditLogData: normalized,
                totalRecords: response.data.count || normalized.length || 0,
                FilteredFromDate: fromDate,
                FilteredToDate: toDate
              },
              () => this.LoaderFunction(false)
            );
          } else {
            this.LoaderFunction(false);
            this.errorMessage(response.data.message || 'Failed to fetch audit logs');
          }
        })
        .catch((error) => {
          this.LoaderFunction(false);
          if (error?.response?.data?.message) this.errorMessage(error.response.data.message);
          else this.errorMessage(error.message);
        });
    } catch (error) {
      this.LoaderFunction(false);
      this.errorMessage(error.message);
    }
  };

  getUsersList = () => {
    try {
      RestAPIService.getAll(Serviceurls.DAY_END_USER_DETAIL_GET + `?show_all=true`)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({ usersList: response.data.data || [] });
          }
        })
        .catch((error) => {
          console.error('Error fetching users list:', error);
        });
    } catch (error) {
      console.error('Error fetching users list:', error);
    }
  };

  closeFilter = () => {
    this.setState({ FilterOpen: false });
  };

  selectedTime = (start, end, error) => {
    this.state.FilterDatas.startTime = start;
    this.state.FilterDatas.endTime = end;
    this.setState({ FilterDatas: this.state.FilterDatas, timeError: error });
  };

  msgClose() {
    this.setState({ isErrorMsg: false, isErrorMsgText: '' });
  }

  gridToolBar = () => {
    let start_time = this.state.FilterDatas.startTime ? new Date(this.state.FilterDatas.startTime) : '';
    let end_time = this.state.FilterDatas.endTime ? new Date(this.state.FilterDatas.endTime) : '';
    let setStartTime =
      start_time === '' ? '' : DateTime.fromJSDate(start_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
    let setEndTime =
      end_time === '' ? '' : DateTime.fromJSDate(end_time).toLocaleString(DateTime.TIME_24_WITH_SECONDS);

    let TextArray = [
      { label: 'From Date', value: formatDate(this.state.FilteredFromDate) },
      { label: 'To Date', value: formatDate(this.state.FilteredToDate) }
    ];

    if (this.state.FilterDatas.startTime !== null && this.state.FilterDatas.endTime !== null) {
      TextArray.push(
        { label: 'Start Time', value: timeOnlyConvert(setStartTime) },
        { label: 'End Time', value: timeOnlyConvert(setEndTime) }
      );
    }

    if (this.state.filterType) TextArray.push({ label: 'Audit Type', value: this.state.filterType });
    if (this.state.filterUser) TextArray.push({ label: 'User', value: this.state.filterUser });

    const ExportData = this.state.auditLogData?.length > 0 ? this.state.auditLogData?.map((item) => {
      return ({
        "Date & Time": item.timestamp,
        "Audit Type": item.module,
        "Reason": item.action,
        "User": item.user,
        "Previous PI No": item.actual_data?.PO_Number,
        "Previous Drug Name": item.actual_data?.Drug_Name || "-",
        "Previous Batch No": item.actual_data?.Batch_Number || "-",
        "Previous Vendor Name": item.actual_data?.Old_Vendor_Name || "-",
        "Previous Bill No": item.actual_data?.Old_Bill_Number || "-",
        "Modified PI No": item.modified_data?.PO_Number,
        "Modified Drug Name": item.modified_data?.Drug_Name || "-",
        "Modified Batch No": item.modified_data?.Batch_Number || "-",
        "Modified Vendor Name": item.modified_data?.New_Vendor_Name || "-",
        "Modified Bill No": item.modified_data?.New_Bill_Number || "-",
      })
    }) : [];

    return (
      <Box>
        <CommonGridToolBarWithFilterTextCustom data={ExportData} title={"Audit Log"} FilterTextArray={TextArray} filename={"Audit Log"} />
      </Box>
    );
  };

  renderFilterScreen = () => {
    const { t } = this.props;
    return (
      <Box component={'div'} className='eMed_rts_filter_container'>
        <Box component={'div'} className='eMed_filter_Top'>
          <Typography variant='h6' fontWeight={600}>
            {t('Filter')}
          </Typography>
          <Button onClick={() => this.setState({ FilterOpen: false })} className='eMed_usrconf_btn'>
            <img src={ImagePaths.LabCloseButton.default} alt='close' className='eMed_action_img_small' />
          </Button>
        </Box>

        <Box className='eMed_rts_middle'>
          <Box className='eMed_date_filter'>
            <CommonDatePicker
              FromDate={this.state.fromDate}
              ToDate={this.state.toDate}
              DateIndex={this.state.dateIndex}
              SelectedDates={this.FilterDate.bind(this)}
              HideAllMenu={true}
            />
          </Box>

          {/* <Box sx={{ width: '22vw' }}>
            <CommonTimeRangePicker
              startTime={this.state.FilterDatas?.startTime}
              endTime={this.state.FilterDatas?.endTime}
              selectedTime={this.selectedTime.bind(this)}
              FromDate={this.state.fromDate}
              ToDate={this.state.toDate}
              onError={this.state.FilterDatas.onError}
            />
          </Box> */}

          <Box className='eMed_rts_dropdown'>
            <Autocomplete
              size='small'
              options={this.state.auditTypes}
              getOptionLabel={(option) => option.label}
              value={this.state.auditTypes.find((type) => type.value === this.state.filterType) || null}
              onChange={(event, newValue) => {
                this.setState({ filterType: newValue?.value || '' });
              }}
              renderInput={(params) => <TextField {...params} label={t('Select Audit Type')} />}
            />
          </Box>

          <Box className='eMed_rts_dropdown'>
            <Autocomplete
              size='small'
              options={this.state.usersList}
              getOptionLabel={(option) => option.user_name}
              value={ this.state.usersList.find( (user) => user.user_name === this.state.filterUser ) || null }
              onChange={(event, newValue) => {
                this.setState({ filterUser: newValue?.user_name || '' });
              }}
              renderInput={(params) => <TextField {...params} label={t('Select User')} />}
            />
          </Box>
        </Box>

        <Stack spacing={2} direction='row' alignItems='center' justifyContent='center'>
          <Button
            variant='outlined'
            size='small'
            onClick={() => {
              this.setState(
                {
                  filterType: '',
                  filterUser: '',
                  fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                  toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                  dateIndex: 1,
                  FilterDatas: { startTime: null, endTime: null, onError: false },
                  timeError: false
                },
                () => this.getAuditLogData()
              );
            }}
            id='eMed_Config_btn'
          >
            {t('Clear')}
          </Button>

          <Button
            variant='contained'
            size='small'
            disabled={
              this.state.FilterDatas.startTime
                ? this.state.FilterDatas.startTime &&
                  this.state.FilterDatas.endTime &&
                  this.state.timeError !== true
                  ? false
                  : true
                : false
            }
            onClick={() => {
              this.getAuditLogData();
              this.setState({ FilterOpen: false });
            }}
            id='eMed_Config_btn'
          >
            {t('Search')}
          </Button>
        </Stack>
      </Box>
    );
  };

  renderDetails = (title1, value1, title2, value2, title3 = "", value3 = "") => {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <Typography fontWeight={600} component="div"
          sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <span style = {{fontSize: "0.8vw"}}>{title1}:</span> {ContentInTooltip(value1, 20, "0.8vw")}</Typography>
        <Typography fontWeight={600} component="div"
          sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <span style = {{fontSize: "0.8vw"}}>{title2}:</span> {ContentInTooltip(value2, 20, "0.8vw")}</Typography>
        {title3 && value3 && <Typography fontWeight={600} 
          component="div" sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <span style = {{fontSize: "0.8vw"}}>{title3}:</span> {ContentInTooltip(value3, 20, "0.8vw")}</Typography>}
      </Box>
    )
  }

  render() {
    const { t } = this.props;
    const { auditLogData, totalRecords } = this.state;

    const columns = [
      { field: 'sno', headerName: 'S.No.', flex: 0.06, align: 'center', headerAlign: 'center' },
      {
        field: 'timestamp',
        headerName: 'Date & Time',
        flex: 0.18,
        renderCell: ({row}) => (<Box>{row?.timestamp || "-"}</Box>)
      },
      { field: 'module', headerName: 'Audit Type', flex: 0.16, renderCell: ({row}) => ContentInTooltip(row?.module, 20) },
      { field: 'action', headerName: 'Reason', flex: 0.2, renderCell: ({row}) => ContentInTooltip(row?.action, 25) },
      { field: 'user', headerName: 'User', flex: 0.14, renderCell: ({row}) => ContentInTooltip(row?.user, 18) },
      {
        field: 'old_values',
        headerName: 'Previous Data',
        flex: 0.25,
        renderCell: ({ row }) => {
          const {actual_data} = row || {};
          return (row?.module === "PO Drug Delete" ?
            this.renderDetails("PI No", actual_data?.PO_Number, "Drug Name", actual_data?.Drug_Name, "Batch No", actual_data?.Batch_Number) :
            row?.module === "PO Vendor Change" ?
              this.renderDetails("PI No", actual_data?.PO_Number, "Vendor Name", actual_data?.Old_Vendor_Name) :
              this.renderDetails("PI No", actual_data?.PO_Number, "Bill No", actual_data?.Old_Bill_Number ))
        },
        valueGetter: (params) => {
          const { row } = params;
          const actual_data = row?.actual_data || {};

          if (row?.module === "PO Drug Delete") {
            return `PI No: ${actual_data.PO_Number || '-'}, Drug Name: ${actual_data.Drug_Name || '-'}, Batch No: ${actual_data.Batch_Number || '-'}`;
          }

          if (row?.module === "PO Vendor Change") {
            return `PI No: ${actual_data.PO_Number || '-'}, Vendor Name: ${actual_data.Old_Vendor_Name || '-'}`;
          }

          return `PI No: ${actual_data.PO_Number || '-'}, Bill No: ${actual_data.Old_Bill_Number || '-'}`;
        },
      },
      {
        field: 'new_values',
        headerName: 'Modified Data',
        flex: 0.25,
        renderCell: ({ row }) => {
          const {modified_data} = row;
          return (row?.module === "PO Drug Delete" ?
            this.renderDetails("PO No", modified_data?.PO_Number, "Drug Name", modified_data?.Drug_Name, "Batch No", modified_data?.Batch_Number) :
            row?.module === "PO Vendor Change" ?
              this.renderDetails("PO No", modified_data?.PO_Number, "Vendor Name", modified_data?.New_Vendor_Name) :
              this.renderDetails("PO No", modified_data?.PO_Number, "Bill No", modified_data?.New_Bill_Number))
        },
        valueGetter: (params) => {
          const { row } = params;
          const modified_data = row?.modified_data || {};

          if (row?.module === "PO Drug Delete") {
            return `PI No: ${modified_data.PO_Number || '-'}, Drug Name: ${modified_data.Drug_Name || '-'}, Batch No: ${modified_data.Batch_Number || '-'}`;
          }

          if (row?.module === "PO Vendor Change") {
            return `PI No: ${modified_data.PO_Number || '-'}, Vendor Name: ${modified_data.New_Vendor_Name || '-'}`;
          }

          return `PI No: ${modified_data.PO_Number || '-'}, Bill No: ${modified_data.New_Bill_Number || '-'}`;
        },
      }
    ];

    const dataWithSno = (auditLogData || [])?.map((row, index) => ({
      ...row,
      sno: index + 1 + this.state.page * this.state.pageSize
    }));

    const disablePrintExcel = this.state.disableBtn || this.state.auditLogData?.length === 0;
        return (
      <Box component={'div'} className='eMed_rts_container'>
        <Box component={'div'} className='eMed_Top_Container'>
          <Box component={'div'} className='eMed_Action_Container' sx={{ width: '100%' }}>
            <Box component={'div'} className='eMed_Filter_Icon_div' display={'flex'} padding={'0.5vw'}>
              <Button className='eMed_usrconf_btn' onClick={() => this.setState({ FilterOpen: true })}>
                <img src={ImagePaths.Filter.default} alt='filter' className='eMed_action_img' />
              </Button>
            </Box>
          </Box>
        </Box>

        <Box component={'div'} className='eMed_rts_table'>
          <DataGrid
            rows={dataWithSno}
            columns={columns}
            getRowId={(row) => row.id}
            page={this.state.page}
            pageSize={this.state.pageSize}
            rowCount={totalRecords}
            paginationMode='server'
            density={'compact'}
            rowHeight={100}
            onPageChange={(newPage) => {
              this.setState({ page: newPage }, () => this.getAuditLogData());
            }}
            onPageSizeChange={(newPageSize) => {
              this.setState({ pageSize: newPageSize, page: 0 }, () => this.getAuditLogData());
            }}
            localeText={{
              toolbarColumns: '',
              toolbarDensity: '',
              toolbarExport: '',
              toolbarFilters: '',
              toolbarExportPrint: ''
            }}
            components={{
              Toolbar: this.gridToolBar,
              NoRowsOverlay: () => <Stack className='eMed_conf_nodata'>{t('NoRecordsFound')}</Stack>
            }}
            rowsPerPageOptions={[10, 20, 30]}
            pagination
            headerHeight={40}
            disableSelectionOnClick
            loading={this.state.isLoader}
            sx={{ '& .MuiDataGrid-cell': { fontSize: '0.875rem' } }}
          />
        </Box>

        <Drawer
          anchor={'right'}
          open={this.state.FilterOpen}
          ModalProps={{ onBackdropClick: this.closeFilter }}
          sx={{ '& .MuiDrawer-paper': { width: '26vw', height: '43ve' } }}
        >
          {this.renderFilterScreen()}
        </Drawer>

        {this.state.isErrorMsg ? (
          <ToastMsg severity={'error'} msg={this.state.isErrorMsgText} msgPop={this.msgClose.bind(this)} />
        ) : null}
      </Box>
    );
  }
}

export default withTranslation()(PharmacyAuditLog);
